var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMargin07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 152,
    viewBox: "0 0 157 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.9995 149.861H120.77L120.77 36.6513L35.9995 36.6513L35.9995 149.861Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36 65.8204H2V36.6504H154.77V65.8204H120.77",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M78.3806 103.541C91.4919 103.541 102.121 92.9118 102.121 79.8005C102.121 66.6893 91.4919 56.0605 78.3806 56.0605C65.2694 56.0605 54.6406 66.6893 54.6406 79.8005C54.6406 92.9118 65.2694 103.541 78.3806 103.541Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M70.3895 72.5996C70.3895 72.5996 67.7695 75.2596 67.7695 79.2596C67.7695 83.2596 69.7695 85.4096 72.8195 85.4096C75.8695 85.4096 77.1295 82.3096 78.1495 78.9996C79.1695 75.6896 80.7795 73.0696 83.4195 73.0696C86.0595 73.0696 88.3395 75.6096 88.3395 79.2496C88.3395 82.8896 85.3895 86.9996 85.3895 86.9996",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M63.4004 79.2598H93.3604",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36 128.85C47.61 128.85 57.02 138.26 57.02 149.87",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M120.77 128.85C109.16 128.85 99.75 138.26 99.75 149.87",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M82.7503 131.33C85.4903 131.33 85.4903 127.08 82.7503 127.08C80.0103 127.08 80.0103 131.33 82.7503 131.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M78.3792 4.25C81.1192 4.25 81.1192 0 78.3792 0C75.6392 0 75.6392 4.25 78.3792 4.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M133.44 85.4609C136.18 85.4609 136.18 81.2109 133.44 81.2109C130.7 81.2109 130.7 85.4609 133.44 85.4609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M55.2405 58.1895C57.9805 58.1895 57.9805 53.9395 55.2405 53.9395C52.5005 53.9395 52.5005 58.1895 55.2405 58.1895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.9502 115.44C24.1038 115.44 26.6602 112.883 26.6602 109.73C26.6602 106.576 24.1038 104.02 20.9502 104.02C17.7967 104.02 15.2402 106.576 15.2402 109.73C15.2402 112.883 17.7967 115.44 20.9502 115.44Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M89.5791 24.7696C92.7327 24.7696 95.2891 22.2132 95.2891 19.0596C95.2891 15.9061 92.7327 13.3496 89.5791 13.3496C86.4256 13.3496 83.8691 15.9061 83.8691 19.0596C83.8691 22.2132 86.4256 24.7696 89.5791 24.7696Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMargin07);
export default __webpack_public_path__ + "static/media/icon_margin_07.2ec51547039ea011d22b6d6c8bb44dd1.svg";
export { ForwardRef as ReactComponent };